import React from 'react';
import { Checkbox } from '.';

export interface CheckboxGroupProps {
  options: { label: string | JSX.Element; value: string }[];
  values: string[];
  onChange: (values: string[]) => void;
  className?: string;
}

export const CheckboxGroup: React.FC<CheckboxGroupProps> = ({ options, values = [], onChange, className }) => {
  const handleChange = (value: string, checked: boolean) => {
    let newValues = [...values];
    if (checked) {
      newValues.push(value);
    } else {
      newValues = newValues.filter((val) => val !== value);
    }
    onChange(newValues);
  };

  return (
    <div className={className}>
      {options.map((option) => (
        <Checkbox
          key={option.value}
          label={option.label}
          checked={values?.includes(option.value)}
          onChange={(checked) => handleChange(option.value, checked)}
        />
      ))}
    </div>
  );
};
